module.exports = __webpack_public_path__ + "img/begin-decorator-circles-mobile.49b8d96d.svg";